import type { WCardTranslations } from "./pl";

export const de: WCardTranslations = {
  triggerAriaLabel: "Ihr Warenkorb",
  drawerTitle: "Ihr Warenkorb",
  drawerClose: "Schließen",
  countLabel: "Menge",
  countDecrement: "Menge verringern",
  countIncrement: "Menge erhöhen",
  deleteItem: "Artikel aus dem Warenkorb entfernen",
  variantColorAlt: "Farbmuster der Variante",
  priceBeforePromotion: "Preis vor der Aktion",
  emptyState: "Ihr Warenkorb ist leer.",
  toPay: "Zu zahlen",
  continueShopping: "Weiter einkaufen",
  pay: "Bestellen",
  updateFailed: "Warenkorb konnte nicht aktualisiert werden.",
  deleteFailed: "Artikel konnte nicht aus dem Warenkorb entfernt werden.",
  updating: "Warenkorb wird aktualisiert…",
  formatPrice: (value: number, currency: string): string => {
    const rounded = (Math.round(value * 100) / 100).toFixed(2).replace(".", ",");
    return currency ? `${rounded} ${currency}` : rounded;
  },
};
